export default __webpack_public_path__ + "alberta-wound.e48cb13dd50c4a5230c0.svg";